import React from 'react';
import './style.css';

interface ConfirmationModalProps {
  text?: React.ReactNode;
  onCancel: () => void;
  onConfirm: () => void;
  top?: number | string;
  right?: number | string;
  showModal?: boolean;
}
const ConfirmationModal = ({
  text = 'Confirm delete?',
  onCancel,
  onConfirm,
  top,
  right,
  showModal,
}: ConfirmationModalProps) => {
  const shouldShow = showModal ?? true;
  const modalStyles: React.CSSProperties = {
    position: 'absolute',
    top: typeof top === 'number' ? `${top}px` : top,
    right: typeof right === 'number' ? `${right}px` : right,
  };
  if (!shouldShow) {
    return null;
  }
  return (
    <div className="delete-confirm-modal" style={modalStyles}>
      <div style={{ whiteSpace: 'pre-wrap' }}>{text}</div>
      <div>
        <button style={{ color: '#265374' }} onClick={onCancel}>
          Cancel
        </button>
        <button style={{ color: '#265374' }} onClick={onConfirm}>
          Confirm
        </button>
      </div>
    </div>
  );
};

export default ConfirmationModal;
